/* Sainté - Creators
   Viser kontaktformularen ét spørgsmål ad gangen. Uden JavaScript står
   alle spørgsmål under hinanden, og formularen sendes som den er.
   Hvert trin tjekkes, før man kommer videre, og knappen bliver til
   «Send ansøgning» på sidste trin. */

if (!customElements.get('sainte-creators')) {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class SainteCreators extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.steps = Array.from(this.querySelectorAll('[data-sc-step]'));
      if (!this.form || this.steps.length < 2) return;

      this.next = this.querySelector('[data-sc-next]');
      this.back = this.querySelector('[data-sc-back]');
      this.progress = this.querySelector('[data-sc-progress]');
      this.count = this.querySelector('[data-sc-count]');
      this.bar = this.querySelector('[data-sc-bar]');
      this.status = this.querySelector('[data-sc-status]');
      this.consent = this.querySelector('[data-sc-consent]');

      // Tjekket sker her, ikke i browserens egne bobler
      this.form.noValidate = true;
      this.classList.add('is-ready');
      this.progress.hidden = false;
      this.index = 0;
      this.show(0, false);

      this.next.addEventListener('click', (event) => {
        if (this.index < this.steps.length - 1) {
          event.preventDefault();
          if (this.check(this.steps[this.index])) this.show(this.index + 1, true);
        }
      });

      this.back.addEventListener('click', () => this.show(this.index - 1, true));

      // Enter i et felt går videre i stedet for at sende formularen
      this.form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target.tagName !== 'INPUT') return;
        if (this.index < this.steps.length - 1) {
          event.preventDefault();
          this.next.click();
        }
      });

      this.form.addEventListener('input', (event) => this.clear(event.target.closest('[data-sc-step]')));
      this.form.addEventListener('change', (event) => this.clear(event.target.closest('[data-sc-step]')));

      // Shopifys hCaptcha lytter også på submit og sender formularen, uanset
      // om andre har kaldt preventDefault. Tjekket kører derfor i capture, før
      // captchaen, og stopper eventet helt, når noget mangler.
      this.form.addEventListener('submit', (event) => {
        const stop = () => {
          event.preventDefault();
          event.stopImmediatePropagation();
        };
        // Et dobbeltklik må ikke sende to ansøgninger. Spærringen slipper igen,
        // hvis captchaen lukkes, så man kan prøve igen.
        if (this.sending) {
          stop();
          return;
        }
        const bad = this.steps.findIndex((step) => !this.check(step, true));
        if (bad !== -1) {
          stop();
          this.show(bad, true);
          this.check(this.steps[bad]);
          return;
        }
        this.sending = true;
        setTimeout(() => {
          this.sending = false;
        }, 3000);
      }, true);
    }

    show(index, focus) {
      if (index < 0 || index >= this.steps.length) return;
      this.index = index;
      const total = this.steps.length;
      const last = index === total - 1;

      this.steps.forEach((step, i) => {
        step.hidden = i !== index;
      });

      this.count.textContent = `${index + 1} / ${total}`;
      this.bar.style.width = `${((index + 1) / total) * 100}%`;
      this.status.textContent = (this.next.dataset.labelStep || '')
        .replace('%c%', index + 1)
        .replace('%t%', total);

      this.next.type = last ? 'submit' : 'button';
      this.next.querySelector('span').textContent = last
        ? this.next.dataset.labelSubmit
        : this.next.dataset.labelNext;
      this.back.hidden = index === 0;
      this.consent.hidden = !last;

      if (!focus) return;
      const wrap = this.closest('#ansog') || this;
      if (wrap.getBoundingClientRect().top < 0) {
        wrap.scrollIntoView({ block: 'start' });
      }
      const field = this.steps[index].querySelector('input:checked, input:not([type="hidden"])');
      if (field) field.focus({ preventScroll: true });
    }

    // Returnerer om trinnet er udfyldt. «quiet» tjekker uden at vise fejl
    check(step, quiet) {
      const inputs = Array.from(step.querySelectorAll('input'));
      const radios = inputs.filter((input) => input.type === 'radio');
      const fields = inputs.filter((input) => input.type !== 'radio');
      let bad = [];

      if (radios.length) {
        if (!radios.some((input) => input.checked)) bad = radios;
      } else if (step.hasAttribute('data-sc-any')) {
        if (!fields.some((input) => input.value.trim())) bad = fields;
      } else {
        bad = fields.filter((input) => !this.valid(input));
      }

      if (quiet) return bad.length === 0;

      const error = step.querySelector('[data-sc-error]');
      if (bad.length) {
        if (radios.length) {
          step.querySelector('.sc-choices').classList.add('invalid');
        } else {
          bad.forEach((input) => input.classList.add('invalid'));
        }
        error.textContent = error.dataset.scError;
        error.hidden = false;
        (bad.find((input) => input.type !== 'radio') || radios[0]).focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    valid(input) {
      const value = input.value.trim();
      if (!value) return !input.required;
      if (input.hasAttribute('data-sc-email')) return EMAIL.test(value);
      if (input.hasAttribute('data-sc-age')) {
        const age = Number(value);
        return Number.isInteger(age) && age >= 18 && age <= 99;
      }
      if (input.hasAttribute('data-sc-phone')) {
        return /^\+?[\d\s()-]+$/.test(value) && value.replace(/\D/g, '').length >= 6;
      }
      return true;
    }

    clear(step) {
      if (!step) return;
      step.querySelectorAll('.invalid').forEach((el) => el.classList.remove('invalid'));
      const error = step.querySelector('[data-sc-error]');
      if (error) error.hidden = true;
    }
  }

  customElements.define('sainte-creators', SainteCreators);
}
